export default __webpack_public_path__ + "static/sso-revolutionizing-385ee1ee79722c3117b73ecc9fe3f54b.png";